import type { Dictionary } from "./it";

export const ca: Dictionary = {
  common: {
    appName: "Eligo",
    next: "Seguent",
    back: "Enrere",
    cancel: "Cancel·lar",
    confirm: "Confirmar",
    save: "Desar",
    close: "Tancar",
    yes: "Si",
    no: "No",
    required: "Camp obligatori",
    select: "Seleccionar",
    loading: "Carregant...",
    error: "Error",
    eligible: "Elegible",
    notEligible: "No elegible",
    inProgress: "En curs",
    info: "Info",
    skipToContent: "Anar al contingut",
    open: "Obrir",
    theme: "Tema",
    language: "Idioma",
    of: "de",
  },
  nav: {
    home: "Inici",
    new: "Nou",
    trials: "Assaigs",
    saved: "Enviats",
    assistant: "Xat",
  },
  assistant: {
    title: "Assistent de protocols",
    subtitle: "Pregunta sobre els protocols dels estudis carregats.",
    documents: "Documents",
    uploadCta: "Puja PDF dels protocols",
    dropHint: "Arrossega aquí o toca per seleccionar (PDF)",
    askPlaceholder: "Fes una pregunta sobre els protocols...",
    send: "Envia",
    thinking: "Llegint els protocols...",
    noProtocols: "Puja almenys un PDF per començar.",
    emptyReady: "Fes una pregunta: respondré segons els protocols carregats.",
    dontKnow: "No trobo aquesta informació en els protocols carregats.",
    sources: "Fonts",
    errorGeneric: "Error en contactar amb l'assistent",
    statusExtracting: "Extraient...",
    statusIndexing: "Indexant...",
    statusReady: "Llest",
    statusError: "Error",
    removeDoc: "Elimina document",
    clearChat: "Esborra la conversa",
    loadedProtocols: "Protocols",
    kbEmpty: "Encara no hi ha protocols disponibles.",
    knowsProtocols: "Coneix els protocols carregats",
  },
  kbAdmin: {
    title: "Gestió de protocols",
    subtitle: "Puja els PDF, genera la base de coneixement i publica-la.",
    export: "Exporta la base de coneixement",
    step1: "Puja els PDF dels protocols a dalt i espera l'estat 'Llest'.",
    step2: "Prem 'Exporta la base de coneixement': es baixa el fitxer protocols-index.json.",
    step3: "A GitHub, puja aquest fitxer a la carpeta public/ (sobreescrivint) i fes commit: el lloc s'actualitza sol.",
  },
  landing: {
    tagline: "Assignacio de pacient a assaigs clinics - agut, hemorragic i post-agut.",
    heroTitle: "Assigna un pacient\na un assaig.",
    newPatient: "Nou pacient",
    newPatientDesc: "Comprova l'elegibilitat en tots els assaigs",
    assistantHeroTitle: "El teu coneixement\ndels assaigs, a l'instant.",
    askCta: "Pregunta sobre els protocols...",
    suggestions: ["Assaigs actius", "Criteris d'inclusio", "Finestres temporals"],
    inProgressTitle: "Pacient en curs",
    pastPatients: "Pacients enviats",
    inProgressSubtitle: "Recuperat de localStorage",
    discard: "Descartar",
    resume: "Continuar",
    catalogTitle: "Cataleg d'assaigs",
    catalogSubtitle: "Explora els criteris de tots els assaigs actius",
    catalogDesc: "Consulta sense pacient, nomes de referencia.",
    patientId: "ID",
    age: "Edat",
    nihss: "NIHSS",
    ltsw: "LTSW",
  },
  workflow: {
    title: "Que vols fer?",
    subtitle: "Selecciona el flux per comencar.",
    eligibilityTitle: "Avaluacio d'elegibilitat",
    eligibilityDesc: "Anamnesi + imatge guiada per identificar assaigs adequats.",
    trialsTitle: "Info d'assaigs",
    trialsDesc: "Cataleg amb criteris d'inclusio/exclusio.",
    quickTitle: "Pacient rapid",
    quickDesc: "Entrada rapida per a pacient ja reclutat.",
  },
  trials: {
    title: "Assaigs clinics",
    countSuffix: "totals",
    searchLabel: "Cercar",
    searchPlaceholder: "nom, categoria, intervencio...",
    filterAll: "Tots",
    filterIschemic: "Isquemic",
    filterHemorrhagic: "Hemorragic",
    filterPostAcute: "Post-agut",
    empty: "Cap assaig coincideix amb els filtres.",
    window: "Finestra",
    backToCatalog: "Cataleg",
    keyCriteria: "Criteris clau",
    imaging: "Imatge",
    intervention: "Intervencio",
    treatment: "Tractament",
    notes: "Notes",
    visits: "Visites de seguiment",
    openRandomizer: "Obrir randomitzador",
    fieldWindow: "Finestra",
    fieldAge: "Edat",
    fieldMrs: "pre-mRS",
    fieldNihss: "NIHSS",
    fieldAspects: "ASPECTS",
    thrombolytic: "Trombolitic",
    thrombectomy: "Trombectomia",
    preEvtLabs: "Labs pre-EVT",
    consent: "Consentiment",
    notFoundTitle: "Assaig no trobat",
    notFoundDesc: "no es al cataleg.",
    backCatalog: "Tornar al cataleg",
  },
  preImaging: {
    title: "Pre-Imatge",
    subtitle: "Anamnesi inicial per a avaluacio WeTrust.",
    identification: "Identificacio",
    patientRecordLabel: "Numero d'historia clinica",
    patientRecordPlaceholder: "ex. 2025-00123",
    anamnesis: "Anamnesi",
    ageLabel: "Edat",
    ageSuffix: "anys",
    nihssHint: "0-42",
    mrsLabel: "pre-mRS",
    mrsHint: "0 autonom - 5 discapacitat severa",
    ltswLabel: "LTSW",
    ltswSuffix: "hores",
    ltswHint: "Hores des de la ultima vegada vist be",
    wakeupTitle: "Wake-up stroke",
    wakeupLabel: "Wake-up stroke",
    wakeupDesc: "Per a WeTrust: permet LTSW fins a 12h si els simptomes s'identifiquen en 6h.",
    wakeupSymptomsLabel: "Simptomes identificats en 6h despres del despertar",
    contextTitle: "Context operatiu",
    angioLabel: "Angiograf Philips disponible?",
    doacLabel: "DOAC (NOAC) en les 48h previes?",
    aceiLabel: "Inhibidor ACE (IECA) en terapia?",
    rangeAge: "Edat entre 0 i 120",
    rangeNihss: "NIHSS entre 0 i 42",
    rangeMrs: "pre-mRS entre 0 i 5",
    rangeLtsw: "LTSW en hores (0-168)",
  },
  preResult: {
    title: "Resultat Pre-Imatge",
    weTrustEligible: "El pacient compleix els criteris WeTrust. Es pot procedir a randomitzacio.",
    weTrustNotEligible: "El pacient no compleix tots els criteris WeTrust. Continuar amb avaluacio post-imatge.",
    doacAlertTitle: "Pacient amb DOAC (NOAC)",
    doacAlertDesc: "Realitzar CTA toracica i nivells del farmac.",
    randomize: "Randomitzar",
    continue: "Continuar",
    weTrustEligibleAnnounce: "WeTrust elegible",
    weTrustNotEligibleAnnounce: "WeTrust no elegible",
  },
  postImaging: {
    title: "Post-Imatge",
    subtitle: "Tipus d'ictus, candidatura i parametres.",
    strokeTypeStep: "Tipus ictus",
    detailsStep: "Detalls",
    confirmStep: "Confirmar",
    strokeTypeLabel: "Tipus d'ictus",
    ischemic: "Isquemic",
    ischemicDesc: "LVO o no-LVO",
    hemorrhagic: "Hemorragic",
    hemorrhagicDesc: "HIC espontania",
    candidacyTitle: "Candidatura per a tractament",
    candidateEvt: "Candidat a trombectomia (EVT)?",
    candidateIvt: "Candidat a trombolisi (IVT)?",
    candidateEligible: "Elegible",
    candidateNotEligible: "No elegible",
    evtTitle: "Imatge EVT",
    evtDesc: "Requerit per a ATHENA, PIVOTAL, MOSTE i altres assaigs EVT.",
    tandemLabel: "Oclusio tandem?",
    tortuosityLabel: "Tortuositat vascular?",
    tortuosityHint: "Si no s'especifica, alguns assaigs seran 'Not indicated'.",
    vesselsLabel: "Vas objectiu",
    vesselsHint: "Selecciona un o mes vasos ocluits.",
    contraTpaLabel: "Contraindicacions a la trombolisi?",
    aspectsLabel: "ASPECTS",
    aspectsHint: "0-10",
    nonEvtTitle: "Confirmacio isquemic no-EVT",
    lesionConfirmedLabel: "Lesio confirmada en imatge (CT / CTP / MRI)?",
    hemTitle: "Parametres hemorragics",
    hemVolumeLabel: "Volum hemorragia",
    hemVolumeSuffix: "mL",
    gcsLabel: "GCS",
    gcsHint: "3-15",
    ivhLabel: "Hemorragia aillada a IVH?",
    secondaryCauseLabel: "Causa secundaria",
    secondaryCauseNone: "Cap",
    seizureLabel: "Convulsions / trombosi / hipersensibilitat a TXA?",
    anticoagLabel: "Terapia anticoagulant",
    anticoagNone: "Cap",
    fastestTitle: "FASTEST - Preguntes addicionals",
    fastestHint: "Nomes es mostra si LTSW < 2h i pre-mRS <= 2.",
    brainstemLabel: "Hemorragia del tronc encefalic?",
    procoagulantLabel: "Farmacs procoagulants en les ultimes 24h?",
    ecgLabel: "Anomalies ECG?",
    thrombosisLabel: "Historia de trombosi aguda?",
    pregnancyLabel: "Embaras?",
    angioplastyLabel: "Angioplastia recent?",
    ivhScoreLabel: "IVH score conegut?",
  },
  summary: {
    title: "Assaigs elegibles",
    subtitle: "Selecciona un o mes assaigs per procedir.",
    noneTitle: "Cap assaig elegible",
    noneDesc: "El pacient no compleix els criteris de cap assaig actiu.",
    proceed: "Procedir al guardat",
    goToPostAcute: "Avaluar post-agut (Librexia)",
    selectedCount: "seleccionats",
  },
  share: {
    title: "Desar a Google Sheet",
    subtitle: "Revisa i envia el registre del pacient.",
    outcomeFor: "Outcome per a",
    intervention: "Intervencio",
    control: "Control",
    notesLabel: "Notes",
    notesPlaceholder: "Notes lliures...",
    messagePreview: "Vista previa del missatge",
    copy: "Copiar",
    sendToSheet: "Enviar a Sheet",
    saveSuccess: "Desat correctament",
    saveError: "Error en desar",
  },
  postAcute: {
    title: "Post-agut (Librexia)",
    subtitle: "Avaluacio per a assaig post-agut.",
    causeSuspectLabel: "Causa aterotrombotica sospitada?",
    persistentLabel: "Simptomes persistents?",
    imagingFindingLabel: "Imatge consistent amb etiologia aterotrombotica?",
    treatmentReceivedLabel: "Tractament rebut en fase aguda?",
    abcd2Label: "Puntuacio ABCD2",
    abcd2Hint: "0-7",
    labsTitle: "Valors de laboratori",
    inrLabel: "INR",
    apttLabel: "aPTT ratio",
    gfrLabel: "TFG",
    chronicAnticoagLabel: "Anticoagulacio cronica en curs?",
    hepaticLabel: "Malaltia hepatica?",
    pregnancyLabel: "Embaras?",
    eligibleTitle: "Librexia elegible",
    notEligibleTitle: "Librexia no elegible",
  },
  trialPatient: {
    title: "Pacient des d'assaig",
    subtitle: "Entrada rapida per a reclutament ja decidit.",
    selectedTrialLabel: "Assaig seleccionat",
    armLabel: "Brac",
    otherTrialsLabel: "Altres assaigs associats",
    addTrial: "Afegir assaig",
    targetVesselLabel: "Vas objectiu",
    acuteTreatmentsLabel: "Tractaments aguts",
    tevLabel: "Trombectomia (TEV)?",
    mticiLabel: "mTICI",
    tivLabel: "Trombolisi (IVT)?",
  },
  extras: {
    show: "Mostrar",
    hide: "Amagar",
    review: "Revisio",
    continueWithoutSelection: "Continuar sense seleccio",
    criteriaMissing: "Criteris que falten",
    proceedHow: "Com vols procedir?",
    sinceLtsw: "des de LTSW",
    activeSession: "Pacient en curs",
    severity: "Severitat",
    patternCause: "Patro i causa",
    eligFactors: "Factors d'elegibilitat",
    isolatedIvh: "Hemorragia aillada IVH",
    isolatedIvhSub: "Hemorragia confinada al sistema ventricular",
    txaExcl: "Exclusio TXA",
    txaExclSub: "Convulsions / trombosi / hipersensibilitat a TXA",
    acuteTreatments: "Tractaments aguts",
    noEligibleTitle: "Cap assaig elegible",
    noEligibleDesc: "El pacient no compleix els criteris de cap assaig actiu.",
    windowIv: "Finestra trombolisi IV",
    windowEvt: "Finestra EVT estandard",
    windowEvtSelected: "Finestra EVT seleccionada (<=24h)",
    windowClosed: "Finestra tancada",
    symptomsWithin6h: "Simptomes en 6h",
    eligibleTrialsCount: "assaigs elegibles",
    results: "Resultats",
    selectDateTime: "Selecciona data i hora",
    setTime: "Confirmar",
    nowL: "Ara",
    tabPatients: "Pacients",
    tabStats: "Estadistiques",
    statScreened: "Screened",
    statEnrolled: "Enrolled",
    statRate: "Rate",
    statIschemic: "Isquemic",
    statHemorrhagic: "Hemorragic",
    statEnrollmentsByTrial: "Reclutaments per assaig",
    statNoData: "Encara no hi ha dades.",
    savedEmpty: "Encara cap pacient desat.",
    savedSubtitle: "Historic local - tap per reobrir",
    savedRemoveConfirm: "Eliminar",
    senza: "(sense ID)",
    age: "Edat",
    volumeTitle: "Volum hemorragia",
    notAvailable: "No disponible",
    volPending: "Volum per definir",
    largeHematoma: "Hematoma extens (>=30 mL)",
    dragVolume: "Arrossega o toca el cercle",
    gcsSevere: "Sever",
    gcsModerate: "Moderat",
    gcsMild: "Lleu",
    coreLarge: "Core extens",
    coreModerate: "Core moderat",
    coreFavorable: "Core favorable",
    vesselsNone: "Cap vas seleccionat",
    ichScore: "ICH Score",
    mortality30: "Mortalitat a 30d:",
    volPendingScore: "Volum pendent - score parcial",
    catalog: "Cataleg",
    fastTag: "Rapid",
    guidedTag: "Guiat",
    directEnroll: "Reclutament directe",
    directEnrollDesc: "Entrada rapida per a pacient ja decidit",
    skipToContent: "Anar al contingut",
    causeNone: "Cap",
    causeTrauma: "Trauma",
    causeAVM: "AVM",
    causeAneurysm: "Aneurisma",
    causeTumor: "Tumor",
    causeOther: "Altra",
    anticoagHep: "Heparina <24h",
    regionPosterior: "Posterior",
    quickSubtitle: "Entrada rapida sense avaluacio d'elegibilitat.",
    quickTrialLabel: "Assaig assignat",
    quickTrialPlaceholder: "Selecciona un assaig...",
    quickArmLabel: "Brac",
    quickIntervention: "Intervencio",
    quickControl: "Control",
    sendDirect: "Enviar directament",
    sentSuccess: "Enviat",
    goHome: "Tornar a l'inici",
    trialsEnrolled: "Assaigs reclutats",
    trialsEligibleNotEnrolled: "Elegibles no reclutats",
    edit: "Editar",
    deleteAction: "Eliminar",
    notFound: "No trobat",
    notInLocalArchive: "Pacient no a l'arxiu local",
    syncToFetch: "Sincronitza la llista per descarregar el pacient del Sheet.",
    missedShort: "missed",
    cloudPill: "cloud",
  },
};
